export interface W3Line {
  id: string;
  name: string;
  category: string;
  description: string;
  photos: string[];
  url: string;
}

export const w3Lines: W3Line[] = [
  {
    id: 'armarios',
    name: 'Armários de Aço',
    category: 'Armários',
    description: 'Linha completa de armários de aço soldados e montáveis, com prateleiras reguláveis, pintura eletrostática a pó e fechamento com chave. Ideais para escritórios, vestiários e ambientes industriais.',
    photos: [
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/52_vviGwtXGIE0Fy14.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/53_oloUH9udDzFbwyL.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/55_8JknE3hqpVhb4hi.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/56_JtopaT70mSVkYY5.png',
    ],
    url: 'https://w3.ind.br/pt/catalogo/mobiliario-corporativo/armarios',
  },
  {
    id: 'armarios-montaveis',
    name: 'Armários Montáveis',
    category: 'Armários',
    description: 'Armários montáveis WM com estrutura robusta em aço, fácil montagem e desmontagem. Disponíveis em diversas configurações de portas e cores personalizáveis para adequar ao ambiente.',
    photos: [
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/59_JP0ZfNa06XbfACO.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/164_o5E7T9YchvsYVeg.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/201_3wOjvnALD7Bb5zW.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/123_EhFjOWZ5LvcBZRs.png',
    ],
    url: 'https://w3.ind.br/pt/catalogo/mobiliario-corporativo/armarios',
  },
  {
    id: 'lockers',
    name: 'Lockers',
    category: 'Lockers',
    description: 'Lockers soldados e montáveis para vestiários e espaços compartilhados. Disponíveis em múltiplas configurações de portas, com cores personalizáveis, sapatas poliméricas e ventilação nas portas.',
    photos: [
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/6_iedMpIlYGei13Hl.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/8_FRjibQad9gNbL0q.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/9_c8J0pSzSFVbb9cJ.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/10_v8ogS1wjtskHh0W.png',
    ],
    url: 'https://w3.ind.br/pt/catalogo/mobiliario-corporativo/lockers',
  },
  {
    id: 'lockers-multiportas',
    name: 'Lockers Multiportas',
    category: 'Lockers',
    description: 'Lockers com múltiplas portas para alta capacidade de armazenamento individual. Modelos soldados WS com 8, 10, 12 e 16 portas, atendendo às normas NR18 e NR24 para ambientes de trabalho.',
    photos: [
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/18_owKEhxZ4zmptXAS.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/19_vDDlgNDQkdkZu2b.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/22_zLnKgYUUzwePwvm.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/24_HBkYjKDZr34KbjH.png',
    ],
    url: 'https://w3.ind.br/pt/catalogo/mobiliario-corporativo/lockers',
  },
  {
    id: 'lockers-montaveis',
    name: 'Lockers Montáveis',
    category: 'Lockers',
    description: 'Lockers montáveis WM para fácil transporte e instalação. Modelos iniciais e de continuação permitem criar fileiras extensas de armários individuais com segurança e praticidade.',
    photos: [
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/27_LYGsGaOPTYeqpkg.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/28_WDmoSgRyxl4yFGp.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/29_Uukp4jFrJlHM0Dc.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/25_myj3kCqmrw0G2Ou.png',
    ],
    url: 'https://w3.ind.br/pt/catalogo/mobiliario-corporativo/lockers',
  },
  {
    id: 'estantes-biblio-z',
    name: 'Estantes Biblio Z',
    category: 'Estantes',
    description: 'Estantes biblioteca linha Z, disponíveis em modelos simples, duplos e expositores, em tamanhos mini e padrão. Estrutura em aço com dobras longitudinais para maior rigidez e resistência.',
    photos: [
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/38_kfCSZtpq2kXND4z.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/39_OC8x2Jcje4gBJoV.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/40_CzoWTXEtwPmoxvH.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/41_o2267vKrrLYciFz.png',
    ],
    url: 'https://w3.ind.br/pt/catalogo/mobiliario-corporativo/estantes',
  },
  {
    id: 'estantes-w-teca',
    name: 'Estantes W-Teca',
    category: 'Estantes',
    description: 'Linha W-Teca de estantes biblioteca com design diferenciado, disponíveis em versões simples, duplas, mini e expositoras. Prateleiras com 3 dobras longitudinais para máxima resistência.',
    photos: [
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/45_jsy458LKaaFEuNN.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/47_AKe5jCJs6OQawM8.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/48_IHBAxwWsPYxoUbX.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/50_I7ImFbweamn3s2Q.png',
    ],
    url: 'https://w3.ind.br/pt/catalogo/mobiliario-corporativo/estantes',
  },
  {
    id: 'estantes-biblioteca-bp',
    name: 'Estantes Biblioteca BP',
    category: 'Estantes',
    description: 'Estantes biblioteca linha BP com múltiplas configurações de prateleiras. Modelos simples, duplos e com reforços laterais em X para maior estabilidade em ambientes de alta demanda.',
    photos: [
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/62_kul4eTvkr6QoBSs.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/63_0iD1FxQiewHdtgw.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/65_3Ojp0OCDmZ5F9b8.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/69_4p1fKUV070CjlnA.png',
    ],
    url: 'https://w3.ind.br/pt/catalogo/mobiliario-corporativo/estantes',
  },
  {
    id: 'arquivos',
    name: 'Arquivos de Aço',
    category: 'Arquivos',
    description: 'Arquivos de aço para organização de documentos e pastas suspensas. Disponíveis em modelos soldados WS e montáveis WM, com 2 e 4 gavetas, trilhos deslizantes em nylon e pintura texturizada.',
    photos: [
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/80_XXNx2UgvswX6HRU.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/81_6y5qGsJR2IgNf5w.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/82_onxLAQJVcdheZWZ.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/83_m3UFUtzgGomjrq8.png',
    ],
    url: 'https://w3.ind.br/pt/catalogo/mobiliario-corporativo/arquivos',
  },
  {
    id: 'arquivos-cinza',
    name: 'Arquivos de Aço (Cinza)',
    category: 'Arquivos',
    description: 'Linha de arquivos de aço na cor cinza, com acabamento texturizado de alta resistência. Modelos com 2 e 4 gavetas para pastas suspensas, com fechamento central por chave e puxadores modernos.',
    photos: [
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/168_3ChVC5d7BBL840z.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/169_rG9zrEaA8Lk38Ny.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/170_jHPOCL9Qbw1VacB.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/171_aPae2GILtmbZ3Af.png',
    ],
    url: 'https://w3.ind.br/pt/catalogo/mobiliario-corporativo/arquivos',
  },
  {
    id: 'gaveteiros',
    name: 'Gaveteiros de Aço',
    category: 'Gaveteiros',
    description: 'Gaveteiros de aço soldados e montáveis para organização de documentos e materiais de escritório. Modelos com 2 e 3 gavetas, com trilhos deslizantes de precisão e fechamento com chave.',
    photos: [
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/130_0gPquPFCZ3nndQb.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/131_2Chho7gbGDFOjd3.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/132_eu2zHX0hX2Osuc6.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/133_D6bFtXnHBmqWQ0S.png',
    ],
    url: 'https://w3.ind.br/pt/catalogo/mobiliario-corporativo/gaveteiros',
  },
  {
    id: 'linha-mullti',
    name: 'Linha Mullti',
    category: 'Armários',
    description: 'Linha Mullti de armários de aço com design moderno e versátil. Disponível em múltiplas configurações de portas e cores, ideal para ambientes corporativos que exigem organização e estética.',
    photos: [
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/123_EhFjOWZ5LvcBZRs.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/124_n914QBHEAs7kjqb.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/125_Hg7WsiNb6DRAFwL.png',
      'https://w3-ind.s3.sa-east-1.amazonaws.com/images/products/126_saRG5aHT4zeDhpJ.png',
    ],
    url: 'https://w3.ind.br/pt/catalogo/mobiliario-corporativo/armarios',
  },
];
